import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from 'partial/components/Button';
import Version from 'partial/components/Version';
import { SolidLogo } from 'modules/common/components/AppIconLogo';
import IconInvalidExpired from 'assets/images/icons/icon-invalid-activation.svg';

function ExpiredForgotPassword() {
  const history = useHistory();
  const handleBackToHomePage = () => history.push('/');

  return (
    <div className="h-full flex flex-col bg-gradient-to-t from-primary-700 to-primary-800">
      <div className="h-full flex flex-col bg-center bg-login">
        <div className="w-full max-w-lg m-auto">
          <div className="flex justify-center mb-6 h-40 relative">
            <SolidLogo />
            <p className="absolute bottom-9 left-60 ml-4 text-xs text-white whitespace-nowrap">
              BILLER PORTAL
            </p>
          </div>
          <div className="m-auto w-full px-14 pb-10 pt-14 rounded-none sm:rounded-3xl bg-white">
            <div className="flex flex-col items-center border-b border-gray-200 pb-6 mb-6">
              <img
                src={IconInvalidExpired}
                alt="expired"
                className="w-36 mb-6"
              />
              <h1 className="text-center text-xl mb-2 font-semibold">
                Reset Password Invalid
              </h1>
              <p className="text-center text-sm text-gray-500 mb-6">
                The reset password link has already been expired and no longer
                valid.
              </p>
              <p className="text-center text-sm text-gray-500">
                You may request another by going back to login page and then
                click forgot password.
              </p>
            </div>
            <div className="flex justify-center">
              <Button outlinePrimary onClick={handleBackToHomePage}>
                Back to Login
              </Button>
            </div>
          </div>
          <p className="text-white text-xs text-center mt-6">
            &copy; 2021 DST Biller Portal <Version />
          </p>
        </div>
      </div>
    </div>
  );
}

export default ExpiredForgotPassword;
